import { fmt_int, fmt_pct0, fmt_signed_pct, fmt_usd2, fmt_usd_short } from "../trade_review/trade_review_model"
import { fmt_units_short, fmt_x, lift_summary, READABLE } from "./promo_lift_review_model"

export type figure_format = "usd_short" | "usd2" | "int" | "units" | "pct0" | "signed_pct" | "x"

const FORMATTERS: Record<figure_format, (value: number) => string> = {
  usd_short: fmt_usd_short,
  usd2: fmt_usd2,
  int: fmt_int,
  units: fmt_units_short,
  pct0: fmt_pct0,
  signed_pct: fmt_signed_pct,
  x: fmt_x,
}

/** One figure from the summary, formatted, so a sentence never holds a typed number. */
export function Fig({ summary, field, as }: { summary: lift_summary; field: string; as: figure_format }) {
  const value = summary[field]
  return <span class="font-medium tabular-nums text-foreground">{typeof value === "number" ? FORMATTERS[as](value) : "—"}</span>
}

export function ReadPill({ read }: { read: string }) {
  return (
    <span class={`inline-block rounded-full border px-2 text-xs whitespace-nowrap ${read === READABLE ? "text-emerald-700 dark:text-emerald-400" : "text-amber-700 dark:text-amber-400"}`}>
      {read}
    </span>
  )
}
